import {gql, useQuery} from "@apollo/client";
import {DSP_FIELDS, DspType} from "../types/DspType";
import { useEffect, useState } from "react";

// 总部「派件车队」列表（含合作仓库与结算配置），下拉场景请用 hooks/useDspOptions 的精简查询
export const GET_DSP_MANAGEMENT_LIST = gql`
  query GetDspManagementList {
    allDsps: getDspManagementList {
      ...DspFields
    }
  }
  ${DSP_FIELDS}
`;

interface GetAllDspsResponse {
    allDsps: DspType[];
}


export const useDspManagementList = () => {
    const [allDsps, setAllDsps] = useState<DspType[]>([]);
    const {data, loading, error, refetch} = useQuery<GetAllDspsResponse>(GET_DSP_MANAGEMENT_LIST);
    useEffect(() => {
        if (data) {
           setAllDsps(data.allDsps.map(dsp => ({...dsp, warehouseIds: dsp.warehouses.map(warehouse => Number(warehouse.id))})));
      }
    }, [data]);

  return {
    allDsps,
    loading,
    refetch,
    error
  };
};
